import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';

import * as yup from 'yup';

/** "NetPing" device response body - DTO signature */
export interface NetPingDeviceFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The device will be permanently deleted six months after this date. */
  deleted?: Date;
  /** User who created this device */
  createdBy?: UserFindInterface;

  // Data columns
  /** Device display name */
  name: string;
  /** Device IP-address */
  ipAddress: string;
  /** Lock indicator channel value OID */
  lockIndicatorOid: string;
  /** Lock indicator channel number */
  lockIndicatorNumber: number;
  /** Lock value OID */
  lockValueOid: string;
  /** Value which marks device as locked */
  lockValue: number;
  /** Is device locked */
  isLocked?: boolean;
}

/** "NetPing" device response body - DTO schema */
export const NetPingDeviceFindDto = SerdeDtoClass.create<NetPingDeviceFindInterface>(PacsDtoKeysEnum.NET_PING_DEVICE_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  createdBy: {
    sortable: true,
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  ipAddress: {
    sortable: true,
    label: 'IP-адрес устройства',
    serializer: yup.string(),
  },
  lockIndicatorOid: {
    label: 'OID значения с номером линии блокировки',
    serializer: yup.string(),
  },
  lockIndicatorNumber: {
    label: 'Номер линии блокировки, который надо прослушивать',
    serializer: yup.number(),
  },
  lockValueOid: {
    label: 'OID флага блокировки',
    serializer: yup.string(),
  },
  lockValue: {
    label: 'Значение флага блокировки, при котором устройство считается заблокированным',
    serializer: yup.number(),
  },
  isLocked: {
    optional: true,
    label: 'Заблокировано ли устройство',
    serializer: yup.boolean(),
  },
});
